import type { PropsWithChildren } from 'react'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import styled from 'styled-components'
import { MIN_LABEL_HEIGHT } from './constants'
import { rem } from 'polished'

const LabelBox = styled(LoadingBox)`
  min-height: ${MIN_LABEL_HEIGHT};
  border-radius: ${props => props.theme.borderRadius.S};
`

interface Props {
  /**
   * in pixels
   */
  width: number
}

function LabelLoadingBox(props: PropsWithChildren<Props>) {
  const { width } = props

  return <LabelBox style={{ width: rem(width) }} />
}

export default LabelLoadingBox
